import { toast } from "react-hot-toast";

export const init_data = {
  Civilite: "", //
  Prenom: "", //
  Nom: "", //
  Email: "", //
  Telephone: "", //
  adresse: "", //
  pays: "", //
  nationalite: "", //
  Niveau: "", //
  Filiere: "", //
  reponse: "", //
  Message: "", //
};

export const validation = (form = init_data) => {
  if (!form.Civilite) {
    toast.error("Civilite est obligatoire");
    return false;
  }

  if (!form.Prenom) {
    toast.error("Prenom est obligatoire");
    return false;
  }

  if (!form.Nom) {
    toast.error("Nom est obligatoire");
    return false;
  }

  if (!form.Email) {
    toast.error("Email est obligatoire");
    return false;
  }

  if (!form.Telephone) {
    toast.error("Telephone est obligatoire");
    return false;
  }

  if (!form.pays) {
    toast.error("Pays est obligatoire");
    return false;
  }

  if (!form.nationalite) {
    toast.error("Nationalite est obligatoire");
    return false;
  }

  if (!form.Niveau) {
    toast.error("Niveau est obligatoire");
    return false;
  }

  if (!form.Filiere) {
    toast.error("Filiere est obligatoire");
    return false;
  }

  if (!form.reponse) {
    toast.error("Comment avez-vous connu l'UIK");
    return false;
  }

  return true;
};
